export default {
  common: {
    unexpected: '예기치 않은 오류가 발생했습니다',
    tryAgain: '나중에 다시 시도해주세요',
    refresh: '페이지 새로고침'
  },
  network: {
    offline: '오프라인 상태인 것 같습니다',
    connectionLost: '연결이 끊어졌습니다',
    serverError: '서버 오류',
    requestFailed: '요청 실패'
  },
  game: {
    loadFailed: '게임을 불러오는데 실패했습니다',
    unsupported: '현재 브라우저가 이 게임을 지원하지 않을 수 있습니다',
    missingDependencies: '게임 실행에 필요한 구성 요소가 누락되었습니다'
  },
  validation: {
    required: '이 필드는 필수입니다',
    email: '유효한 이메일 주소를 입력해주세요',
    minLength: '최소 {min}자 이상 입력해주세요',
    maxLength: '{max}자를 초과할 수 없습니다'
  }
}; 